import styles from './dropdownModal.module.css';
import downArrow from '../../assets/down-arrow.png';
import { DropdownModalProps } from './dropdownModal.types';
import { useEffect, useRef } from 'react';

const DropdownModal = (props: DropdownModalProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        props.handleClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  return (
    <div className={`${styles.wrapper}`} ref={dropdownRef}>
      <div
        className={`${styles.dropdownModal} ${
          (props.isOpen || props.isDisabled) && styles.active
        } ${props.dropdownClassName} `}
        onClick={() => {
          if (props.isDisabled) return;
          props.handleClick();
        }}
      >
        {props.label} <img src={downArrow} alt="" />
      </div>

      {props.isOpen && (
        <div
          className={`${styles.content} ${
            props.contentAlign === 'left' ? styles.left : styles.right
          } ${props.contentClassName}`}
        >
          {props.children}
        </div>
      )}
    </div>
  );
};

export default DropdownModal;
